import {GetOdontoDatesParams} from 'domain/usecases';
import {makeGetOdontoDates} from 'main/factories/usecases';
import {sortDateStringArray} from 'presentation/utils';

async function getOdontoDates(params: GetOdontoDatesParams) {
	const dates = await makeGetOdontoDates().get(params);

	if (!dates) {
		return [];
	}

	return sortDateStringArray(dates);
}

export {getOdontoDates};
